<div class="select-card">

  @if (label()) {
    <label class="floating-label" [for]="'select-' + (label() ?? '')">{{ label() }}</label>
  }

  <div
    class="floating-wrapper"
    [class.is-open]="isOpen"
    [class.is-loading]="loading()"
    [class.is-disabled]="isDisabled || loading()"
    role="combobox"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isOpen"
  >

    <!-- ── Icône gauche (chevron ou flèche selon état) ── -->
    <span class="input-icon" aria-hidden="true">
      @if (loading()) {
        <!-- Spinner inline SVG animé -->
        <svg class="spin-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2" stroke-dasharray="40 20" stroke-linecap="round"/>
        </svg>
      } @else {
        <!-- Icône liste / select -->
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <line x1="8"  y1="6"  x2="21" y2="6"  stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <line x1="8"  y1="12" x2="21" y2="12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <line x1="8"  y1="18" x2="21" y2="18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <circle cx="3" cy="6"  r="1.2" fill="currentColor"/>
          <circle cx="3" cy="12" r="1.2" fill="currentColor"/>
          <circle cx="3" cy="18" r="1.2" fill="currentColor"/>
        </svg>
      }
    </span>

    <!-- ── Champ texte de recherche / affichage ── -->
    <input
      type="text"
      [id]="'select-' + (label() ?? '')"
      [value]="displayValue"
      [placeholder]="loading() ? 'Chargement...' : placeholder()"
      [disabled]="isDisabled || loading()"
      (input)="onSearch($event)"
      (focus)="onFocus()"
      (blur)="onBlurInput()"
      class="input-root"
      autocomplete="off"
      [attr.aria-label]="label()"
      [attr.aria-controls]="'select-list-' + (label() ?? '')"
    />

    <!-- ── Chevron droite ── -->
    <span class="select-chevron" [class.is-open]="isOpen" aria-hidden="true">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <polyline points="6 9 12 15 18 9"
                  stroke="currentColor" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>

    <!-- ── Dropdown ── -->
    @if (isOpen && !loading()) {
      <ul
        class="select-list"
        role="listbox"
        [id]="'select-list-' + (label() ?? '')"
      >
        @if (filteredOptions.length === 0) {
          <li class="select-option select-option--empty" role="option">
            Aucune option trouvée
          </li>
        }
        @for (option of filteredOptions; track option.value) {
          <li
            class="select-option"
            [class.is-selected]="option.value === selectedValue"
            role="option"
            [attr.aria-selected]="option.value === selectedValue"
            (mousedown)="selectOption(option)"
          >
            @if (option.value === selectedValue) {
              <svg class="option-check" width="14" height="14" viewBox="0 0 24 24" fill="none">
                <polyline points="20 6 9 17 4 12"
                          stroke="currentColor" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            }
            {{ option.label }}
          </li>
        }
      </ul>
    }

    <span class="input-state" aria-hidden="true"></span>
  </div>
</div>